import React, {useState, useEffect} from 'react';
import {Modal, Button, Form, InputGroup} from 'react-bootstrap';

interface MailingList {
  id: string;
  adresse: string;
  membres?: string[];
}

interface EditMailingListModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (updatedList: MailingList) => void;
  mailingList: MailingList | null;
  domainName: string;
}

const EditMailingListModal: React.FC<EditMailingListModalProps> = ({
  show,
  onHide,
  onSave,
  mailingList,
  domainName,
}) => {
  const [localPart, setLocalPart] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (mailingList) {
      // Extraire la partie locale de l'adresse existante
      const parts = mailingList.adresse.split('@');
      setLocalPart(parts[0] || '');
    }
  }, [mailingList]);

  const validateLocalPart = (local: string): boolean => {
    // Validation de la partie locale uniquement
    const localPartRegex = /^[a-zA-Z0-9._-]+$/;
    return local.length > 0 && localPartRegex.test(local);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!localPart.trim()) {
      setError('Le nom de la liste est obligatoire');
      return;
    }

    if (!validateLocalPart(localPart)) {
      setError('Format invalide. Utilisez uniquement des lettres, chiffres, points, tirets et underscores');
      return;
    }

    if (mailingList) {
      const fullAddress = `${localPart}@${domainName}`;
      onSave({
        ...mailingList,
        adresse: fullAddress,
      });
    }
    handleClose();
  };

  const handleClose = () => {
    setError('');
    onHide();
  };

  if (!mailingList) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Modifier la liste de diffusion</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>
              Adresse de la liste <span className="text-danger">*</span>
            </Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="liste"
                value={localPart}
                onChange={(e) => {
                  setLocalPart(e.target.value);
                  setError('');
                }}
                isInvalid={!!error}
                autoFocus
                required
              />
              <InputGroup.Text>@{domainName}</InputGroup.Text>
            </InputGroup>
            {error && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {error}
              </Form.Control.Feedback>
            )}
            <Form.Text className="text-muted">
              Saisissez uniquement la partie avant le @
            </Form.Text>
          </Form.Group>

          {mailingList.membres && mailingList.membres.length > 0 && (
            <div className="alert alert-info">
              <i className="fa-solid fa-info-circle me-2"></i>
              Cette liste contient <strong>{mailingList.membres.length}</strong> membre(s)
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="primary" type="submit">
            <i className="fa-solid fa-save me-2"></i>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditMailingListModal;
